import type {JourneyAudienceAction} from 'src/action-creators/journey-audience';
import type {MemberCount, AudienceList} from 'src/types/audience-list';
import {
  UPDATE_STATE,
  RECEIVE_SELECTED_LISTS,
  SET_INCLUDED_LISTS,
  SET_EXCLUDED_LISTS,
  RESET,
  SET_MEMBER_COUNT,
  SET_MEMBER_COUNT_LOADING,
} from 'src/action-creators/journey-audience';


export type JourneyAudienceState = {
  includedLists: Map<string, Partial<AudienceList>>;
  excludedLists: Map<string, Partial<AudienceList>>;
  memberCounts: Map<string, Partial<MemberCount>>;
};

const initialState = {
  includedLists: new Map(),
  excludedLists: new Map(),
  memberCounts: new Map(),
} as const;

export default (
  state: JourneyAudienceState = initialState,
  action: JourneyAudienceAction,
): JourneyAudienceState => {
  switch (action.type) {
    case UPDATE_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case RECEIVE_SELECTED_LISTS: {
      return {
        ...state,
        includedLists: new Map([
          ...state.includedLists.entries(),
          ...action.payload.includedLists.entries(),
        ]),
        excludedLists: new Map([
          ...state.excludedLists.entries(),
          ...action.payload.excludedLists.entries(),
        ]),
      };
    }
    case SET_INCLUDED_LISTS: {
      return {
        ...state,
        includedLists: action.payload,
      };
    }
    case SET_EXCLUDED_LISTS: {
      return {
        ...state,
        excludedLists: action.payload,
      };
    }
    case SET_MEMBER_COUNT_LOADING: {
      const {listIds = [], isLoading = false} = action.payload ?? {};
      const newMemberCount = new Map(state.memberCounts);
      listIds.forEach((id) => {
        const listData = newMemberCount.get(String(id));
        newMemberCount.set(String(id), {...listData, isLoading});
      });

      return {
        ...state,
        memberCounts: newMemberCount,
      };
    }
    case SET_MEMBER_COUNT: {
      const currentMemberCount = state.memberCounts;
      const newMemberCount = new Map(currentMemberCount);
      for (const [key, value] of action.payload) {
        const currentData = currentMemberCount.get(String(key));
        newMemberCount.set(String(key), {
          ...currentData,
          ...value,
          isLoading: false,
        });
      }

      return {
        ...state,
        memberCounts: newMemberCount,
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
  }

  return state;
};
